export const SUPPORT_EMAIL = process.env.REACT_APP_EMAIL_SUPPORT ?? 'global.humanitarianbooking@wfp.org';
export const REACT_APP_HBH_FRONTEND_URL = process.env.REACT_APP_HBH_API_URL?.replace('/api/v2', '')